// start:ng42.barrel
export * from './stay-pref.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/stay-pref/stay-pref/index.ts